import React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import './header.scss';
import Formulaire from '../body/formulaire/Formulaire';

export default function Header() {
    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar position="fixed">
                <Grid 
                direction='row'
                justifyContent='space-between'
                alignItems='center'
                container 
                sx={{ backgroundColor: '#ede8e2 !important', padding: '1vh' }}>
                    <Grid item sm={12} lg={6} className='assoText'>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1, color: 'black' }}>
                            <strong>M</strong>
                            <small style={{color: 'gray', }}>ontpellier </small> 
                            <strong>P</strong>
                            <small style={{color: 'gray', }}>rotection du </small> 
                            <strong>P</strong>
                            <small style={{color: 'gray', }}>atrimoine et des </small>
                            <strong>C</strong>
                            <small style={{color: 'gray', }}>ommerces</small>
                        </Typography>
                    </Grid>
                    <Grid item sm={12} lg={6} direction='row' justifyContent='end' sx={{display: 'flex'}}>
                        <Formulaire />
                    </Grid>
                </Grid>
            </AppBar>
        </Box>
    );
}
